import { useQuery } from "@tanstack/react-query";
import userService from "@/lib/services/userService";
import regionsService from "@/lib/services/regionsService";
import { Region, UserProfile } from "@/lib/services/types";
import { useAuthSync } from "./useAuthSync";

export const useUser = (): {
  user: UserProfile;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
} => {
  const {
    data: profile,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ["userProfile"],
    queryFn: userService.getProfile,
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: useAuthSync().isAuthenticated,
  });

  return {
    user: profile as UserProfile,
    isLoading: isLoading || isFetching,
    error,
    refetch: async () => {
      await refetch();
    },
  };
};

export const useRegion = (): {
  regionData: Region;
  isLoading: boolean;
  error: Error | null;
} => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["user-region"],
    queryFn: regionsService.getRegion,
    enabled: useAuthSync().isAuthenticated,
  });

  return { regionData: data as Region, isLoading, error };
};
